import { render, staticRenderFns } from "./YinhuashuiTableSwitcher.vue?vue&type=template&id=12ef6f30&scoped=true&"
import script from "./YinhuashuiTableSwitcher.vue?vue&type=script&lang=js&"
export * from "./YinhuashuiTableSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./YinhuashuiTableSwitcher.vue?vue&type=style&index=0&id=12ef6f30&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ef6f30",
  null
  
)

export default component.exports